import { render, staticRenderFns } from "./galeriaCinco.vue?vue&type=template&id=109f2bea&scoped=true"
import script from "./galeriaCinco.vue?vue&type=script&lang=js"
export * from "./galeriaCinco.vue?vue&type=script&lang=js"
import style0 from "./galeriaCinco.vue?vue&type=style&index=0&id=109f2bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109f2bea",
  null
  
)

export default component.exports